/* eslint-disable react/prop-types */
import React from 'react'
import {
    JOB_INDEX_SEE_MORE_BUTTON
} from 'assets/AlertsHelper'
import { Box, Grid } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import { FormattedMessage } from 'react-intl'
import TechlinkJobCard from '../TechlinkJobCard/TechlinkJobCard'
import ShowMoreButton from 'components/CTAAlert/ShowMoreButton/ShowMoreButton'
import { useStyles } from './TechlinkJobItemIndex_style'

const TechlinkJobItemIndex = (props) => {
    if (props.items.length === 0) return null
    const classes = useStyles()

    const showMoreClick = () => {
        props.filterItems(false)
    }

    return (
        <Box className='item-index-container'>
            <Box className={`cards-and-list ${props.type}-type`}>
                {!props.loading && props.items.length > 0 && (
                    <Box>
                        <Grid container spacing={2}>
                            {props.items.map((job) => {
                                return (
                                    <Grid key={`article-job-${job.id}`} item  xs={12}>
                                        <TechlinkJobCard
                                            job={job}
                                        />
                                    </Grid>
                                )
                            })}
                        </Grid>
                        <Box className={classes.button}>
                            <ShowMoreButton
                                type={props.type}
                                user={props.user}
                                origin={JOB_INDEX_SEE_MORE_BUTTON}
                                loadingMore={props.loadingMore}
                                loadMoreStatus={props.loadMoreStatus}
                                showMoreAction={showMoreClick}
                            />
                        </Box>
                    </Box>
                )}
                {props.loadingMore && (
                    <Box display='flex' justifyContent='center' fullWidth my={4}>
                        <CircularProgress color='primary' style={{ width: '80px', height: '80px' }} />
                    </Box>
                )}
                {!props.loading && props.items.length === 0 && (
                    <Box mt={4} mb={8}>
                        <Typography variant='body2'>
                            <FormattedMessage id='item_index.no_found_offer' />
                        </Typography>
                    </Box>
                )}
            </Box>
        </Box>
    )
}

export default TechlinkJobItemIndex
